import IndustrySolutionI18n from "@/components/landing/shared/IndustrySolutionI18n";
import { Clock, MapPin, Calendar, MessageSquare } from "lucide-react";
const LoesungTourismusSection = () => <IndustrySolutionI18n translationPrefix="industryTourismus" icons={[Clock, MapPin, Calendar, MessageSquare]} />;
export default LoesungTourismusSection;
